import { useDispatch, useSelector } from 'react-redux';
import useUserProfile from './useUserProfile';

const usePhysicianStatusEdit = () => {
  const { userProfile } = useUserProfile();
  const status = userProfile.attributes.status || '';
  const statusSetAt = userProfile.attributes.statusSetAt || '';
  const isSaving = useSelector(state => state.loading.effects.superuser.savePhysicianStatus);

  const dispatch = useDispatch();
  const { savePhysicianStatus } = dispatch.superuser;

  return {
    status,
    statusSetAt,
    isSaving,
    savePhysicianStatus,
  };
};

export default usePhysicianStatusEdit;
